import { render } from "./file-cell.vue?vue&type=template&id=3dd9ca8c&scoped=true"
import script from "./file-cell.vue?vue&type=script&lang=js"
export * from "./file-cell.vue?vue&type=script&lang=js"

import "./file-cell.vue?vue&type=style&index=0&id=3dd9ca8c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\gurmi\\Projects\\anyform\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd9ca8c"]])

export default __exports__